import React from 'react';
import GuestFeedbackApp from './GuestFeedbackApp';

function getRoomFromPath() {
  const match = window.location.pathname.match(/^\/r\/([^/?#]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

function App() {
  const room = getRoomFromPath();

  if (!room) {
    return (
      <div className="stage">
        <div className="phone">
          <div className="screen bare" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
            <div style={{ textAlign: 'center', color: '#fff' }}>
              <h1 style={{ fontFamily: 'Philosopher, system-ui, sans-serif', fontWeight: 400 }}>Guest QR Feedback</h1>
              <p style={{ opacity: 0.85, fontSize: 14 }}>Scan your room QR or open <code>/r/222</code></p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <GuestFeedbackApp roomNumber={room} />;
}

export default App;
